import { type FunctionComponent, useCallback, useMemo } from 'react';
import useSWR from 'swr';

import { fetchRegionalFeedUrl } from 'common/api/feed';
import { doFetch } from 'common/baseFetch';
import ForecastArticlesCarousel from 'components/ForecastArticlesCarousel';
import type {
  ForecastArticlesContainerProps,
  ForecastArticlesResponse,
} from 'types/forecastArticles';

interface ApiResponse {
  associated: {
    keywords?: string[];
    nextStart?: string;
  };
  data: {
    regional: ForecastArticlesResponse['regional'];
  };
}

const ForecastArticlesContainer: FunctionComponent<ForecastArticlesContainerProps> = ({
  className,
  emptyText,
  mode = 'light',
  pageName,
  subregionId,
  subregionName,
}) => {
  const fetchUrl = useMemo(
    () => fetchRegionalFeedUrl(subregionId, undefined, 10, true),
    [subregionId],
  );

  const { data, error, isLoading, mutate } = useSWR<ApiResponse>(fetchUrl, doFetch, {
    errorRetryCount: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  const handleRetry = useCallback(() => {
    mutate();
  }, [mutate]);

  return (
    <div className={className}>
      <ForecastArticlesCarousel
        articles={data?.data?.regional || []}
        emptyText={emptyText}
        error={error}
        isLoading={isLoading}
        mode={mode}
        onRetry={handleRetry}
        pageName={pageName}
        subregionId={subregionId}
        subregionName={subregionName}
        title={subregionName}
        viewAllLink="/surf-news/"
      />
    </div>
  );
};

export default ForecastArticlesContainer;
